export const initialEvents = [
  {
    id: 1,
    title: 'Toulouse Poker Festival',
    startDate: '2026-01-08',
    endDate: '2026-01-11',
    color: 'bg-blue-600',
    participating: true,
    logoUrl: 'https://cdn-icons-png.flaticon.com/512/8637/8637099.png',
    description: 'Le rendez-vous incontournable des passionnés de poker en région toulousaine organisé par Fivebet',
    subEvents: [
      {
        id: 11,
        title: 'Pink City - 180€',
        description: 'NLH Pink City - Tournoi d\'ouverture',
        date: '2026-01-08',
        time: '20:00',
        participating: true,
        detailedInfo: {
          location: 'Casino Barrière Toulouse',
          duration: '1 soirée (niveaux de 30 min)',
          organizer: 'Fivebet Poker',
          buyIn: '150€ + 30€',
          prizePool: 'À déterminer',
          startingStack: '20 000 jetons',
          blindStructure: '100/200 - 30 min',
          attendees: ['150+ joueurs attendus'],
          agenda: [
            'Registration 19h30',
            'Shuffle up 20h00',
            'Late registration : 8 niveaux',
            'Format semi-rapide',
            'Prévision finale vers minuit'
          ],
          notes: 'L\'événement emblématique du jeudi soir pour lancer le festival dans une ambiance conviviale. Parfait pour débuter le weekend poker toulousain !'
        }
      },
      {
        id: 12,
        title: 'Main Event Day 1A - 300€',
        description: 'NLH Main Event Championship',
        date: '2026-01-09',
        time: '15:00',
        participating: true,
        detailedInfo: {
          location: 'Casino Barrière Toulouse',
          duration: '3 jours (niveaux de 40 min)',
          organizer: 'Fivebet Poker',
          buyIn: '260€ + 40€',
          prizePool: 'À déterminer selon le field',
          startingStack: '30 000 jetons',
          blindStructure: '100/100 - 40 min',
          attendees: ['300+ joueurs sur les 3 flights'],
          agenda: [
            'Day 1A - Vendredi 15h00',
            'Day 1B - Samedi 13h00',
            'Day 1C - Samedi 21h00 (Turbo)',
            'Late registration : 10 niveaux',
            'Day 2 - Dimanche 14h00'
          ],
          notes: 'Le Main Event du festival sur 3 flights ! Structure équilibrée avec 30 000 jetons de départ. Trois journées de départ pour optimiser vos chances.'
        }
      },
      {
        id: 13,
        title: 'Main Event Day 1B - 300€',
        description: 'NLH Main Event Championship',
        date: '2026-01-10',
        time: '13:00',
        participating: true,
        detailedInfo: {
          location: 'Casino Barrière Toulouse',
          duration: '3 jours (niveaux de 40 min)',
          organizer: 'Fivebet Poker',
          buyIn: '260€ + 40€',
          prizePool: 'À déterminer selon le field',
          startingStack: '30 000 jetons',
          blindStructure: '100/100 - 40 min',
          attendees: ['300+ joueurs sur les 3 flights'],
          agenda: [
            'Day 1A - Vendredi 15h00',
            'Day 1B - Samedi 13h00',
            'Day 1C - Samedi 21h00 (Turbo)',
            'Late registration : 10 niveaux',
            'Day 2 - Dimanche 14h00'
          ],
          notes: 'Deuxième flight du Main Event en journée le samedi. Idéal pour ceux qui préfèrent jouer dans la journée avec une structure confortable.'
        }
      },
      {
        id: 14,
        title: 'Main Event Day 1C Turbo - 300€',
        description: 'NLH Main Event Championship (Turbo)',
        date: '2026-01-10',
        time: '21:00',
        participating: false,
        detailedInfo: {
          location: 'Casino Barrière Toulouse',
          duration: '3 jours (niveaux de 20 min)',
          organizer: 'Fivebet Poker',
          buyIn: '260€ + 40€',
          prizePool: 'À déterminer selon le field',
          startingStack: '30 000 jetons',
          blindStructure: '100/100 - 20 min',
          attendees: ['300+ joueurs sur les 3 flights'],
          agenda: [
            'Day 1A - Vendredi 15h00',
            'Day 1B - Samedi 13h00',
            'Day 1C - Samedi 21h00 (Turbo)',
            'Late registration : 8 niveaux',
            'Day 2 - Dimanche 14h00'
          ],
          notes: 'Flight turbo en soirée pour ceux qui ont manqué les deux premiers départs ou qui veulent tenter un deuxième bullet. Format accéléré avec niveaux de 20 minutes.'
        }
      },
      {
        id: 15,
        title: 'TooLoose Bounty K.O Progressive - 220€',
        description: 'NLH Progressive Knockout',
        date: '2026-01-11',
        time: '14:00',
        participating: true,
        detailedInfo: {
          location: 'Casino Barrière Toulouse',
          duration: '1 journée (niveaux de 30 min)',
          organizer: 'Fivebet Poker',
          buyIn: '180€ + 40€ (dont bounty progressif)',
          prizePool: 'À déterminer',
          startingStack: '25 000 jetons',
          blindStructure: '100/200 - 30 min',
          attendees: ['150+ joueurs'],
          agenda: [
            'Registration 13h30',
            'Début 14h00',
            'Format bounty progressif',
            'Late reg : 8 niveaux',
            'Finale prévue en soirée'
          ],
          notes: 'Le tournoi phare du dimanche avec bounties progressifs ! Chaque élimination augmente votre prime. Ambiance explosive garantie pour clôturer le festival.'
        }
      }
    ]
  },
  {
    id: 2,
    title: 'Winamax Poker Tour - Bordeaux',
    startDate: '2026-01-10',
    endDate: '2026-01-11',
    color: 'bg-red-600',
    participating: true,
    logoUrl: 'https://cdn-icons-png.flaticon.com/512/3079/3079403.png',
    description: 'Étape du Winamax Poker Tour à Bordeaux - Tournois 100% Freeroll organisés par Texapoker',
    subEvents: [
      {
        id: 21,
        title: 'WiPT Freeroll Day 1 - Gratuit',
        description: 'Freeroll de qualification - Day 1',
        date: '2026-01-10',
        time: '14:00',
        participating: true,
        detailedInfo: {
          location: 'Bordeaux (lieu à confirmer)',
          duration: '2 jours',
          organizer: 'Winamax & Texapoker',
          buyIn: '0€ (Freeroll)',
          prizePool: 'Qualifications pour la Grande Finale',
          startingStack: 'À confirmer',
          blindStructure: 'À confirmer',
          attendees: ['Qualifiés online et satellites live'],
          agenda: [
            'Day 1 - Samedi 14h00',
            'Freeroll 100% gratuit',
            'Qualifiez-vous pour la Grande Finale',
            'Day 2 - Dimanche',
            'Grande Finale : Pasino Grand Aix-en-Provence (20-30 mars 2026)'
          ],
          notes: 'Étape 100% gratuite du Winamax Poker Tour ! Qualifiez-vous online via les Sit&Go Starting Block ou les Tremplins Winamax. Une chance unique de participer à la Grande Finale d\'Aix-en-Provence.'
        }
      },
      {
        id: 22,
        title: 'WiPT Freeroll Day 2 - Gratuit',
        description: 'Freeroll de qualification - Day 2',
        date: '2026-01-11',
        time: '14:00',
        participating: true,
        detailedInfo: {
          location: 'Bordeaux (lieu à confirmer)',
          duration: 'Journée finale',
          organizer: 'Winamax & Texapoker',
          buyIn: '0€ (Freeroll)',
          prizePool: 'Qualifications pour la Grande Finale',
          startingStack: 'À confirmer',
          blindStructure: 'À confirmer',
          attendees: ['Qualifiés du Day 1'],
          agenda: [
            'Day 2 - Dimanche 14h00',
            'Reprise du Day 1',
            'Détermination des qualifiés',
            'Les meilleurs joueurs valident leur ticket',
            'Direction la Grande Finale à Aix !'
          ],
          notes: 'Journée finale pour décrocher votre place pour la Grande Finale du WiPT à Aix-en-Provence du 20 au 30 mars 2026. Un rêve accessible à tous !'
        }
      }
    ]
  },
  {
    id: 3,
    title: 'Winamax Poker Tour - Saint-Malo',
    startDate: '2026-01-17',
    endDate: '2026-01-18',
    color: 'bg-cyan-600',
    participating: false,
    logoUrl: 'https://cdn-icons-png.flaticon.com/512/3079/3079403.png',
    description: 'Étape du Winamax Poker Tour à Saint-Malo - Tournois 100% Freeroll organisés par Texapoker',
    subEvents: [
      {
        id: 31,
        title: 'WiPT Freeroll Day 1 - Gratuit',
        description: 'Freeroll de qualification - Day 1',
        date: '2026-01-17',
        time: '14:00',
        participating: false,
        detailedInfo: {
          location: 'Saint-Malo (lieu à confirmer)',
          duration: '2 jours',
          organizer: 'Winamax & Texapoker',
          buyIn: '0€ (Freeroll)',
          prizePool: 'Qualifications pour la Grande Finale',
          startingStack: 'À confirmer',
          blindStructure: 'À confirmer',
          attendees: ['Qualifiés online et satellites live'],
          agenda: [
            'Day 1 - Samedi 14h00',
            'Freeroll 100% gratuit',
            'Qualifiez-vous pour la Grande Finale',
            'Day 2 - Dimanche',
            'Grande Finale : Pasino Grand Aix-en-Provence (20-30 mars 2026)'
          ],
          notes: 'Étape bretonne du WiPT dans la cité corsaire ! Ambiance marine et poker au programme. Qualifications online disponibles sur Winamax.fr'
        }
      },
      {
        id: 32,
        title: 'WiPT Freeroll Day 2 - Gratuit',
        description: 'Freeroll de qualification - Day 2',
        date: '2026-01-18',
        time: '14:00',
        participating: false,
        detailedInfo: {
          location: 'Saint-Malo (lieu à confirmer)',
          duration: 'Journée finale',
          organizer: 'Winamax & Texapoker',
          buyIn: '0€ (Freeroll)',
          prizePool: 'Qualifications pour la Grande Finale',
          startingStack: 'À confirmer',
          blindStructure: 'À confirmer',
          attendees: ['Qualifiés du Day 1'],
          agenda: [
            'Day 2 - Dimanche 14h00',
            'Reprise du Day 1',
            'Détermination des qualifiés',
            'Les meilleurs joueurs valident leur ticket',
            'Direction la Grande Finale à Aix !'
          ],
          notes: 'Dernière chance de décrocher votre qualification pour la Grande Finale ! Le poker gratuit dans un cadre exceptionnel en bord de mer.'
        }
      }
    ]
  },
  {
    id: 4,
    title: 'Partouche Poker Deepstack',
    startDate: '2026-01-21',
    endDate: '2026-01-25',
    color: 'bg-purple-700',
    participating: true,
    logoUrl: 'https://cdn-icons-png.flaticon.com/512/2618/2618245.png',
    description: 'Renaissance du circuit mythique ! Première étape au Pasino Grand La Tour-de-Salvagny organisée par Texapoker et Partouche',
    subEvents: [
      {
        id: 41,
        title: 'L\'Arène - 250€ KO',
        description: 'NLH Knockout - Tournoi d\'ouverture',
        date: '2026-01-21',
        time: '20:00',
        participating: true,
        detailedInfo: {
          location: 'Pasino Grand La Tour-de-Salvagny',
          duration: '2 jours (niveaux de 40 min)',
          organizer: 'Texapoker & Groupe Partouche',
          buyIn: '250€ (dont bounty)',
          prizePool: 'À déterminer',
          startingStack: '30 000 jetons',
          blindStructure: '100/200 - 40 min',
          attendees: ['200+ joueurs attendus'],
          agenda: [
            'Day 1 - Mardi 20h00',
            'Format Knockout',
            'Late registration : 10 niveaux',
            'Day 2 - Mercredi 15h00',
            'Structure confortable avec bounties'
          ],
          notes: 'Tournoi d\'ouverture du festival en format Knockout. Parfait pour lancer le Partouche Poker Deepstack en action avec des éliminations récompensées !'
        }
      },
      {
        id: 42,
        title: 'PPD Main Event Day 1 - 500€',
        description: 'NLH Deepstack Championship - Structure Premium',
        date: '2026-01-23',
        time: '15:00',
        participating: true,
        detailedInfo: {
          location: 'Pasino Grand La Tour-de-Salvagny',
          duration: '3 jours (niveaux de 55 min)',
          organizer: 'Texapoker & Groupe Partouche',
          buyIn: '500€',
          prizePool: 'À déterminer selon le field',
          startingStack: '55 000 jetons',
          blindStructure: '100/100 - 55 min (5 niveaux doublés)',
          attendees: ['300+ joueurs sur les 2 flights'],
          agenda: [
            'Day 1A - Jeudi 15h00',
            'Day 1B - Vendredi 15h00',
            'Structure DEEPSTACK : 55 000 jetons',
            'Niveaux de 55 minutes (5 niveaux doublés)',
            'Day 2 - Samedi 15h00',
            'Day 3 - Dimanche jusqu\'au winner'
          ],
          notes: 'Le Main Event mythique du Partouche Poker Deepstack ! Structure ultra-premium avec 55 000 jetons et niveaux de 55 minutes dont 5 levels doublés. Le vrai poker deep stack !'
        }
      },
      {
        id: 43,
        title: 'PPD Main Event Day 1B - 500€',
        description: 'NLH Deepstack Championship - Structure Premium',
        date: '2026-01-24',
        time: '15:00',
        participating: true,
        detailedInfo: {
          location: 'Pasino Grand La Tour-de-Salvagny',
          duration: '3 jours (niveaux de 55 min)',
          organizer: 'Texapoker & Groupe Partouche',
          buyIn: '500€',
          prizePool: 'À déterminer selon le field',
          startingStack: '55 000 jetons',
          blindStructure: '100/100 - 55 min (5 niveaux doublés)',
          attendees: ['300+ joueurs sur les 2 flights'],
          agenda: [
            'Day 1A - Jeudi 15h00',
            'Day 1B - Vendredi 15h00',
            'Structure DEEPSTACK : 55 000 jetons',
            'Niveaux de 55 minutes (5 niveaux doublés)',
            'Day 2 - Samedi 15h00',
            'Day 3 - Dimanche jusqu\'au winner'
          ],
          notes: 'Deuxième et dernier flight du Main Event PPD. C\'est votre dernière chance de participer à ce tournoi d\'exception avec une structure parmi les meilleures de France !'
        }
      },
      {
        id: 44,
        title: 'Le Classic - 250€',
        description: 'NLH Classic Weekend',
        date: '2026-01-25',
        time: '14:00',
        participating: false,
        detailedInfo: {
          location: 'Pasino Grand La Tour-de-Salvagny',
          duration: '1 journée (niveaux de 40 min)',
          organizer: 'Texapoker & Groupe Partouche',
          buyIn: '250€',
          prizePool: 'À déterminer',
          startingStack: '30 000 jetons',
          blindStructure: '100/200 - 40 min',
          attendees: ['150+ joueurs'],
          agenda: [
            'Dimanche 14h00',
            'Format one-day confortable',
            'Late registration : 8 niveaux',
            'Structure équilibrée',
            'Finale en soirée'
          ],
          notes: 'Le tournoi du dimanche pour clôturer le festival en beauté ! Format one-day idéal pour ceux qui veulent rejouer après le Main Event ou qui n\'ont que le dimanche de disponible.'
        }
      }
    ]
  },
  {
    id: 5,
    title: 'Winamax Poker Tour - Lille',
    startDate: '2026-01-24',
    endDate: '2026-01-25',
    color: 'bg-orange-600',
    participating: false,
    logoUrl: 'https://cdn-icons-png.flaticon.com/512/3079/3079403.png',
    description: 'Étape du Winamax Poker Tour à Lille - Avant-dernière étape avant la Grande Finale',
    subEvents: [
      {
        id: 51,
        title: 'WiPT Freeroll Day 1 - Gratuit',
        description: 'Freeroll de qualification - Day 1',
        date: '2026-01-24',
        time: '14:00',
        participating: false,
        detailedInfo: {
          location: 'Lille (lieu à confirmer)',
          duration: '2 jours',
          organizer: 'Winamax & Texapoker',
          buyIn: '0€ (Freeroll)',
          prizePool: 'Qualifications pour la Grande Finale',
          startingStack: 'À confirmer',
          blindStructure: 'À confirmer',
          attendees: ['Qualifiés online et satellites live'],
          agenda: [
            'Day 1 - Samedi 14h00',
            'Freeroll 100% gratuit',
            'Avant-dernière étape du WiPT',
            'Day 2 - Dimanche',
            'Grande Finale : Pasino Grand Aix-en-Provence (20-30 mars 2026)'
          ],
          notes: 'L\'étape nordiste du Winamax Poker Tour ! Avant-dernière chance de se qualifier pour la Grande Finale d\'Aix-en-Provence. L\'ambiance ch\'ti au rendez-vous !'
        }
      },
      {
        id: 52,
        title: 'WiPT Freeroll Day 2 - Gratuit',
        description: 'Freeroll de qualification - Day 2',
        date: '2026-01-25',
        time: '14:00',
        participating: false,
        detailedInfo: {
          location: 'Lille (lieu à confirmer)',
          duration: 'Journée finale',
          organizer: 'Winamax & Texapoker',
          buyIn: '0€ (Freeroll)',
          prizePool: 'Qualifications pour la Grande Finale',
          startingStack: 'À confirmer',
          blindStructure: 'À confirmer',
          attendees: ['Qualifiés du Day 1'],
          agenda: [
            'Day 2 - Dimanche 14h00',
            'Reprise du Day 1',
            'Avant-dernière étape de qualification',
            'Dernières places pour Aix',
            'Ne ratez pas cette chance !'
          ],
          notes: 'Journée finale de l\'étape lilloise. Plus qu\'une étape après celle-ci (Lyon 31 jan - 1er fév) avant la Grande Finale !'
        }
      }
    ]
  },
  {
    id: 6,
    title: 'Winamax Poker Tour - Lyon',
    startDate: '2026-01-31',
    endDate: '2026-02-01',
    color: 'bg-yellow-600',
    participating: true,
    logoUrl: 'https://cdn-icons-png.flaticon.com/512/3079/3079403.png',
    description: 'Dernière étape du Winamax Poker Tour avant la Grande Finale d\'Aix-en-Provence !',
    subEvents: [
      {
        id: 61,
        title: 'WiPT Freeroll Day 1 - Gratuit',
        description: 'Freeroll de qualification - DERNIÈRE ÉTAPE !',
        date: '2026-01-31',
        time: '14:00',
        participating: true,
        detailedInfo: {
          location: 'Lyon (lieu à confirmer)',
          duration: '2 jours',
          organizer: 'Winamax & Texapoker',
          buyIn: '0€ (Freeroll)',
          prizePool: 'Qualifications pour la Grande Finale',
          startingStack: 'À confirmer',
          blindStructure: 'À confirmer',
          attendees: ['Qualifiés online et satellites live'],
          agenda: [
            'Day 1 - Samedi 31 janvier 14h00',
            'DERNIÈRE ÉTAPE avant la Grande Finale !',
            'Freeroll 100% gratuit',
            'Day 2 - Dimanche 1er février',
            'Grande Finale : Pasino Grand Aix-en-Provence (20-30 mars 2026)'
          ],
          notes: 'C\'EST LA DERNIÈRE ÉTAPE ! Votre ultime chance de vous qualifier en live pour la Grande Finale du WiPT à Aix-en-Provence. Ne la manquez pas !'
        }
      },
      {
        id: 62,
        title: 'WiPT Freeroll Day 2 - Gratuit',
        description: 'Freeroll de qualification - ULTIME CHANCE !',
        date: '2026-02-01',
        time: '14:00',
        participating: true,
        detailedInfo: {
          location: 'Lyon (lieu à confirmer)',
          duration: 'Journée finale',
          organizer: 'Winamax & Texapoker',
          buyIn: '0€ (Freeroll)',
          prizePool: 'Qualifications pour la Grande Finale',
          startingStack: 'À confirmer',
          blindStructure: 'À confirmer',
          attendees: ['Qualifiés du Day 1'],
          agenda: [
            'Day 2 - Dimanche 1er février 14h00',
            'Reprise du Day 1',
            'DERNIERS TICKETS pour Aix !',
            'Détermination des derniers qualifiés',
            'Rendez-vous à la Grande Finale !'
          ],
          notes: 'La toute dernière journée de qualification live pour la Grande Finale WiPT ! Après cette étape, il ne restera plus que les qualifications online. C\'est maintenant ou jamais !'
        }
      }
    ]
  }
];
